import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-youtube"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1 11.5C1 7.72876 1 5.84315 2.17157 4.67157C3.34315 3.5 5.22876 3.5 9 3.5H15C18.7712 3.5 20.6569 3.5 21.8284 4.67157C23 5.84315 23 7.72876 23 11.5V12.5C23 16.2712 23 18.1569 21.8284 19.3284C20.6569 20.5 18.7712 20.5 15 20.5H9C5.22876 20.5 3.34315 20.5 2.17157 19.3284C1 18.1569 1 16.2712 1 12.5V11.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9.80078 15.3024L15.501 12.0008L9.80078 8.69922V15.3024Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M1 11.5C1 7.72876 1 5.84315 2.17157 4.67157C3.34315 3.5 5.22876 3.5 9 3.5H15C18.7712 3.5 20.6569 3.5 21.8284 4.67157C23 5.84315 23 7.72876 23 11.5V12.5C23 16.2712 23 18.1569 21.8284 19.3284C20.6569 20.5 18.7712 20.5 15 20.5H9C5.22876 20.5 3.34315 20.5 2.17157 19.3284C1 18.1569 1 16.2712 1 12.5V11.5Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9.80078 15.3024L15.501 12.0008L9.80078 8.69922V15.3024Z","strokeWidth":"props.strokeWidth"}}]}]};

const LogoYoutube = Vue.extend<IconProps>({
  name: 'LogoYoutubeIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-youtube',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoYoutube;
